vec3 displace(vec3 pos, vec2 uv, inout float elevation)
{
    return pos;
}
